import axios from 'axios';
import { protectedResources } from './../auth/azure-ad-b2c';
import { getToken, getTenantURL } from './apiToken';
import { requestId } from './config';


export const getInboxEnvelopes = async () => {
   const accessToken = await getToken(protectedResources.apiInboxEnvelopes.scopes.read);
   const tenantId = await getTenantURL();

   const headers = new Headers();
   const bearer = `Bearer ${accessToken}`;

   headers.append('Authorization', bearer);

   const response = await axios({
      method: 'get',
      url: protectedResources.apiInboxEnvelopes.endpoint,
      headers: {
         Authorization: bearer,
         'x-tenantid': tenantId
      }
   });

   return response.data;
};

export const getEnvelope = async (id) => {
   const accessToken = await getToken(protectedResources.apiEnvelope.scopes.read);
   const tenantId = await getTenantURL();

   const headers = new Headers();
   const bearer = `Bearer ${accessToken}`;

   headers.append('Authorization', bearer);

   const response = await axios({
      method: 'get',
      url: protectedResources.apiEnvelope.endpoint + `/${id}`,
      headers: {
         Authorization: bearer,
         'x-tenantid': tenantId
      }
   });

   return response.data;
};

export const getEnvelopeStatusCount = async () => {
   const accessToken = await getToken(protectedResources.apiEnvelopeStatusCount.scopes.read);
   const tenantId = await getTenantURL();

   const headers = new Headers();
   const bearer = `Bearer ${accessToken}`;

   headers.append('Authorization', bearer);

   const response = await axios({
      method: 'get',
      url: protectedResources.apiEnvelopeStatusCount.endpoint,
      headers: {
         Authorization: bearer,
         'x-tenantid': tenantId
      }
   });

   return response.data;
};

export const envelopeUpdateSigner = async (envelopeId, data) => {
   try {
      const accessToken = await getToken(protectedResources.apiEnvelopeUpdateSignerDetails.scopes.read);
      const tenantId = await getTenantURL();

      const headers = new Headers();
      const bearer = `Bearer ${accessToken}`;

      headers.append('Authorization', bearer);

      const response = await axios({
         method: 'put',
         url: protectedResources.apiEnvelopeUpdateSignerDetails.endpoint.replace('{envelopeId}', envelopeId),
         data: JSON.stringify(data),
         headers: {
            Authorization: bearer,
            'x-tenantid': tenantId,
            'Content-Type': 'application/json',
            'x-requestid': requestId,
         }
      })

      return response;
   }
   catch (error) {
      return error
   }
};

